var _rect, _circle, _path, _circle2, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClientWired(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 177,
    height: 32,
    viewBox: "0 0 177 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 28,
    height: 28,
    rx: 7.724,
    fill: "#E8DEF1",
    stroke: "#510C76"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.003,
    cy: 15.517,
    r: 3.862,
    fill: "#fff",
    stroke: "#510C76"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m15.227 14.201 1.546 2.633",
    stroke: "#510C76",
    strokeLinecap: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.997,
    cy: 22.276,
    r: 0.5,
    fill: "#510C76",
    stroke: "#510C76",
    strokeWidth: 0.931
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#500D76",
    d: "M30 15.5h116"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M147.647 2.5h24.706c1.186 0 2.147.961 2.147 2.147v22.059a2.147 2.147 0 0 1-2.147 2.147h-24.706a2.147 2.147 0 0 1-2.147-2.147V4.647c0-1.186.961-2.147 2.147-2.147z",
    stroke: "#510C76",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M153.647 12.912h2.588v-2.265c0-.357.29-.647.647-.647h6.794c.358 0 .648.29.648.647v2.265h2.264c.358 0 .647.29.647.647V21a.647.647 0 0 1-.647.647h-12.941A.647.647 0 0 1 153 21v-7.441c0-.357.29-.647.647-.647z",
    fill: "#E8DEF1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M157.853 15.177v3.882m2.588-3.883v3.883m2.588-3.883v3.883m-6.794-6.147h-2.588a.647.647 0 0 0-.647.647V21c0 .357.29.647.647.647h12.941c.358 0 .647-.29.647-.647v-7.441a.647.647 0 0 0-.647-.647h-2.264v-2.265a.647.647 0 0 0-.648-.647h-6.794a.647.647 0 0 0-.647.647v2.265z",
    stroke: "#510C76",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClientWired);
export default __webpack_public_path__ + "static/media/clientWired.e1ce16b0db4b7cb9ffacca4fa98d9e0b.svg";
export { ForwardRef as ReactComponent };